import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import * as loginSelectors from '../../../../root-store/login-store/login.selector';
import { AddTrustTemplateDialogComponent } from '../../add-trust-template-dialog/add-trust-template-dialog.component';
import { AddTrustTemplate } from '../../add-trust-template-dialog/add-trust-template.interfaces';
import { ManageExitingTemplateListType, ManageTemplateListType, TemplateConfigurationListTypes } from './manage-template.interface';
import { ManageTemplateTypeComponent } from '../manage-template-type/manage-template-type.component';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { NotifyDocumentCreatedAddAsRolePlayers } from '@app/shared/services/notify-document-created-add-as-roleplayers/notify-document-created-add-as-roleplayers';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { CreateMiniFromStepperComponent } from '../../create-mini-from-stepper/create-mini-from-stepper.component';
import { AddEntityDilaogComponent } from '@app/modules/vault/components/dialogs/add-entity-dilaog/add-entity-dilaog.component';
import { NotifyNewVaultCreated } from '@app/shared/services/notify-new-vault-created/notify-new-vault-created';
function Required(target: object, propertyKey: string) {
  Object.defineProperty(target, propertyKey, {
    get() {
      throw new Error(`Attribute ${propertyKey} is required`);
    },
    set(value) {
      Object.defineProperty(target, propertyKey, {
        value,
        writable: true,
        configurable: true,
      });
    },
    configurable: true,
  });
}

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'manage-templates',
  templateUrl: './manage-templates.component.html',
  styleUrls: ['./manage-templates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageTemplatesComponent implements OnInit, OnDestroy {
  /* 
    data : Pass List which you want to display
      data = [{
        profile_image_url: null,
        form_name: null,
        type: null,
        vault_user_form_id: null,
        user_id: null
      }]
    placeHolder: PlaceHolder text
    selectedTemplate: pass already selected value
      selectedTemplate: [{
        id: null
      }]
    selectionChange: Method when user select from list
    templateConfigurationList: Pass Template configuration list for create new template
      templateConfigurationList = [{
        label: null,
        id: null,
        type: null
      }]
  */

  @ViewChild('inputField', { read: ElementRef }) inputField: ElementRef<HTMLInputElement>;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;

  @Input() data: ManageTemplateListType[] = [];
  @Input() placeHolder = '';
  @Input() origin = '';
  @Input() allowedOne = false;
  // capital commitment is also using this flag now so please if any changes made here please make sure to update the capital commitment component also
  @Input() isShowFooter = true;
  @Input() removedRightPadding = false;
  @Input() isDiscoveryContentTemplate = false;
  @Input() selectedTemplate: ManageExitingTemplateListType[] = [];
  @Input() templateConfigurationList: TemplateConfigurationListTypes[] = [];
  @Input() isComboInput = false;
  @Input({ required: true }) @Required hub_vault_user_form_id: string;
  @Input() isInputFullWidth = false;
  @Input() disableSearch = false;
  @Input() isbalanceSheetOwner = false;
  @Input() isFromLinkedTemplate = false;
  @Input() isPositionValueShown = false;
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onComboInputBlur: EventEmitter<any> = new EventEmitter<any>();
  subscription = new Subscription();
  connectionUserFormControl = new UntypedFormControl();

  isInputFocused: boolean = false;
  loadOnce = false;
  loader: boolean = false;
  searchValue = '';
  currentUser;

  constructor(
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private loginService: LoginStoreEffects,
    private store: Store,
    private _notifyNewVaultCreated: NotifyNewVaultCreated,
    private _notifyDocumentCreatedAddAsRolePlayers: NotifyDocumentCreatedAddAsRolePlayers
  ) {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data) {
          if (state?.data?.id && !this.loadOnce) {
            this.loadOnce = true;
          }
        }
      })
    );
  }

  ngOnInit(): void {
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.currentUser = result;
        }
      })
    );

    if(this.disableSearch) {
      this.connectionUserFormControl.disable();
    }
  }

  onTrustSearch(value) {
    this.connectionUserFormControl.setValue(value);
    this.cd.detectChanges();
  }

  onInputFocus() {
    this.isInputFocused = true;
  }

  onInputBlur() {
    this.isInputFocused = false;
    if (this.onComboInputBlur) {
      this.inputField.nativeElement.blur();
      this.onComboInputBlur.emit();
    }
  }

  onClearInput() {
    this.autocomplete.closePanel();
    this.connectionUserFormControl.setValue('');
    this.cd.detectChanges();
  }

  selectConnectedUser(user) {
    this.selectionChange.emit(user);
  }

  addNewTemplate(item) {
    this.autocomplete.closePanel();
    this.inputField.nativeElement.blur();
    if (item?.is_security_key_added) {
      this.selectionChange.emit({
        add_new: true,
      });
    } else {
      if (item.isGroup) {
        if (item.groupList.length == 1) {
          const groupData = {
            id: item.groupList[0].id,
            label: item.groupList[0].type,
            type: item.groupList[0].type,
            hub_vault_user_form_id: this.hub_vault_user_form_id,
          };
          this.openCreateTrustType(groupData);
          return;
        }

        if (item.label && item.label !== 'Entities') {
          const dialogRef = this.dialog.open<ManageTemplateTypeComponent>(ManageTemplateTypeComponent, {
            data: {
              groupList: item.groupList,
              title: item.label,
            },
          });

          this.subscription.add(
            dialogRef.afterClosed().subscribe(
              (res) => {
                this.autocomplete.closePanel();
                if (res) {
                  const groupData = {
                    id: res.id,
                    label: res.type,
                    type: res.type,
                    hub_vault_user_form_id: this.hub_vault_user_form_id,
                  };
                  this.openCreateTrustType(groupData);
                }
              },
              (error) => {}
            )
          );
        } else {
          this.openCreateEntityDialog();
        }
      } else {
        this.openCreateTrustType(item);
      }
    }
  }

  openCreateTrustType(item) {
    this.autocomplete.closePanel();
    const dialogRef = this.dialog.open<CreateMiniFromStepperComponent, AddTrustTemplate>(CreateMiniFromStepperComponent, {
      data: {
        inbox_attachment_id: undefined,
        vault_id: undefined,
        vaultFormId: item.id,
        title: item.type,
        vaultType: item.type,
        hub_vault_user_form_id: null,
        origin: this.origin,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe(
        (res) => {
          if (res) {
            this.subscription.add(this._notifyDocumentCreatedAddAsRolePlayers.sendMessage(res));
            setTimeout(() => {
              const itemData = this.data.filter((item) => item.id === res.id);
              this.autocomplete.closePanel();
              this.selectionChange.emit({ ...res, ...itemData[0] });
            }, 2000);
          }
        },
        (error) => {}
      )
    );
  }

  openCreateEntityDialog() {
    const dialogRef = this.dialog.open(AddEntityDilaogComponent, {
      panelClass: 'full-window-dialog',
      autoFocus: false,
      data: {},
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (res.status && res.data) {
          this.subscription.add(this._notifyDocumentCreatedAddAsRolePlayers.sendMessage(res.data));
          setTimeout(() => {
            const itemData = this.data.filter((item) => item.id === res.data.id);
            this.autocomplete.closePanel();
            this.selectionChange.emit({ ...res.data, ...itemData[0] });
            this._notifyNewVaultCreated.sendMessage(res.data);
          }, 2000);
        }
      })
    );
  }

  onFocusFromParent() {
    setTimeout(() => {
      this.inputField.nativeElement.focus();
      this.isInputFocused = true;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
